import { Document } from '@contentful/rich-text-types'
import { pxToRems } from '@awaze/design-system.components.global-style'
import { breakpoints } from '@awaze/design-system.utils.react'
import RichText from '@/components/RichText/RichText'
import styled from 'styled-components'

export interface TextModuleProps {
  text?: Document
  marginTopDesktop?: number
  marginBottomDesktop?: number
  marginTopMobile?: number
  marginBottomMobile?: number
}

const RichTextContainer = styled(RichText)<{
  marginTopDesktop: string
  marginBottomDesktop: string
  marginTopMobile: string
  marginBottomMobile: string
}>`
  margin-top: ${({ marginTopDesktop }) => marginTopDesktop};
  margin-bottom: ${({ marginBottomDesktop }) => marginBottomDesktop};

  @media (max-width: ${breakpoints[0]}px) {
    margin-top: ${({ marginTopMobile }) => marginTopMobile};
    margin-bottom: ${({ marginBottomMobile }) => marginBottomMobile};
  }
`

export const TextModule: React.FC<TextModuleProps> = ({
  text,
  marginBottomDesktop,
  marginBottomMobile,
  marginTopDesktop,
  marginTopMobile,
}) => {
  const defaultMargin = '2rem'

  return (
    text && (
      <RichTextContainer
        content={text}
        marginTopDesktop={
          marginTopDesktop !== undefined
            ? pxToRems(marginTopDesktop)
            : defaultMargin
        }
        marginBottomDesktop={
          marginBottomDesktop !== undefined
            ? pxToRems(marginBottomDesktop)
            : defaultMargin
        }
        marginTopMobile={
          marginTopMobile !== undefined
            ? pxToRems(marginTopMobile)
            : defaultMargin
        }
        marginBottomMobile={
          marginBottomMobile !== undefined
            ? pxToRems(marginBottomMobile)
            : defaultMargin
        }
      />
    )
  )
}
